import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';

import { Typography, Empty } from 'antd';

import LearningAdminModuleSeriesGridList from '../containers/LearningAdminModuleSeriesGridListContainer';

const { Title, Text } = Typography;

const LearningAdminModuleSeriesGridScreen = ({
  moduleSerieTypes,
  total,
  setShowList,
  setGlobalTotal,
  view,
  activeKey,
  trackerActions,
  ...props
}) => {
  useEffect(() => {
    setShowList(total);
    setGlobalTotal(total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  return (
    <Translation>
      {(t) => (
        <>
          {total === 0 && (
            <div className='learning-empty'>
              <Empty
                description={
                  <>
                    <Title level={3} className='learning-empty-title'>
                      {t('learning_empty_title')}
                    </Title>
                    <Text>{t('learning_empty_description')}</Text>
                  </>
                }
              />
            </div>
          )}

          {moduleSerieTypes.map((x) => (
            <LearningAdminModuleSeriesGridList
              trackerActions={trackerActions}
              action={x.action}
              value={x.value}
              view={view}
              activeKey={activeKey}
            />
          ))}
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleSeriesGridScreen);

Logger.log('silly', `LearningAdminModuleSeriesGridScreen loaded.`);
